import React from 'react';
import Image from 'next/image';

interface ImageProps {
  imageSize: { width: number; height: number };
}

const SAVE_INSTALLATION_IMAGE_HUG = '/td-home/images/landingpage/hero/hug/discount-badge.png';

export const HugDiscountHeroBadge: React.FC<ImageProps> = ({ imageSize }) => {
  return (
    <div className={'save-installation position-absolute'}>
      <Image
        className="save-installation-image mt-3 position-relative"
        width={imageSize.width}
        height={imageSize.height}
        src={SAVE_INSTALLATION_IMAGE_HUG}
        alt={'Jetzt noch Installation sichern!'}
      />
    </div>
  );
};
